
// src/connects/chat-messages-page.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import { emitAlertMessage } from '../actions/alert-message'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { trackPage } from '../helpers/analytics'
import socketRsync from '../helpers/socket-rsync'
import find from 'lodash/find'
import filter from 'lodash/filter'
import each from 'lodash/each'
import moment from 'moment'
import ui from '../helpers/ui-state'

const MAX_DISPLAY_NAME = 6

export const mapStateToProps = (state, ownProps)=> {
  const room_item = state.chatMessages[ownProps.params.chat_room_id]

  return {
    isFetching: room_item ? room_item.isFetching : false,
    isFetchFailed: room_item ? room_item.isFetchFailed : false,
    hasMore: room_item ? room_item.hasMore : true,
    chatRoom: find(state.chatRooms.items, (item)=> item.chat_room_id == ownProps.params.chat_room_id),
    chatMessages: room_item ? room_item.items : undefined,
    user: state.user.current,
    likeConfig: state.likes? state.likes.likeConfig: {},
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  const filteredMembers = stateProps.chatRoom ? filter(stateProps.chatRoom.members, (member) => member.user_id != stateProps.user.user_id) : [];
  const thumbnail = stateProps.chatRoom && stateProps.chatRoom.members.length == 2 && filteredMembers[0] && filteredMembers[0].icon_image && filteredMembers[0].icon_image.thumb_url || undefined;
  const icon = stateProps.chatRoom && stateProps.chatRoom.members.length > 2 && "people" || undefined;
  const members = stateProps.chatRoom ? filteredMembers.slice(0, 3).map(member => member.name).join(', ') : '';


  const otherMembers = stateProps.chatRoom && filter(stateProps.chatRoom.members, (member)=> member.user_id != stateProps.user.user_id) || []

  const name = otherMembers && otherMembers.slice(0, 3).map((member)=> member.name).join(', ') +
                    (otherMembers.length > 3 && ' ' + '...' || '')

  const userData =  stateProps.chatRoom && filter(stateProps.chatRoom.members, (member)=> member.user_id != stateProps.user.user_id)
  var messageData = []
  var members_name = []
  stateProps.chatMessages && each(stateProps.chatMessages, (message, i)=> {
    /**
     * メッセージの間隔が５分以上なら、時間を表示
     */
    if (i != 0 && moment(stateProps.chatMessages[i - 1].created_at).add(-5, 'minutes').isAfter(message.created_at)){
      messageData.push({
        message_id: message.created_at,
        created_at: moment(stateProps.chatMessages[i - 1].created_at),
      })
    }
    /**
     * チャットルーム名が変更された場合
     */
    if (message.message_type == 'name_changed') {
      messageData.push({
        message_id: message.message_id,
        message: message,
      })
    }
    else {
      if (i == 0) {
          members_name = message.user.name
        }
      /**
       * 同じmessage_typeのメッセージを連続して受信した場合
       * 表示する名前をまとめ、messageDataの最後の要素を削除する
       */
      else {
        if ( message.message_type && stateProps.chatMessages[i - 1].message_type == message.message_type ) {
          members_name = members_name + ', ' + message.user.name
          messageData.pop()
        }
        else
          members_name = message.user.name
      }
      let selectUser = find(userData, (users)=> users.user_id == message.user.user_id)

      messageData.push({
        message_id: message.message_id,
        withName: otherMembers && otherMembers.length > 1 ,
        direction: message.user.user_id == stateProps.user.user_id,
        message: {
          chat_room_id: message.chat_room_id,
          message_id: message.message_id,
          message_type: message.message_type,
          user: {
            user_id: message.user.user_id,
            name: members_name,
            icon_image: message.user.icon_image && message.user.icon_image,
            description: selectUser && selectUser.description && selectUser.description
          },
          readers: message.readers && message.readers,
          files: message.files && message.files,
          message: message.message && message.message,
          attach_json: message.attach_json && message.attach_json,
          likes: message.likes && message.likes,
        }
      })
    }
  })
  /**
   * chatMessagesの一番最後に時刻を入れる
   * いつからチャットが始まったかわかるように
   */
  stateProps.chatMessages && stateProps.chatMessages.length > 0 &&
    messageData.push({
      message_id: 'beginning',
      created_at: moment(stateProps.chatMessages[stateProps.chatMessages.length - 1].created_at),
    })

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    chatRoomName: {
      name: stateProps.chatRoom && (stateProps.chatRoom.name || (stateProps.chatRoom.members.length > 4 ? members + ownProps.t('label:他n人', { n: stateProps.chatRoom.members.length - 4 }) : members)) || undefined,
      chat_room_id: stateProps.chatRoom && stateProps.chatRoom.chat_room_id || undefined,
      thumbnail: thumbnail,
      icon: icon,
      unread_count: stateProps.chatRoom && stateProps.chatRoom.unread_count || undefined,
    },
    otherMembers: otherMembers,
    name: name,
    messageData: messageData,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    fetchMessages: (props)=> dispatch(actions.fetchChatMessages(ownProps.params.chat_room_id, props.chatMessages && props.chatMessages.length || 0)),

    joinChatRoom: (user_id)=> dispatch(actions.joinChatRoom(ownProps.params.chat_room_id, user_id)),

    leaveChatRoom: (user_id)=> dispatch(actions.leaveChatRoom(ownProps.params.chat_room_id, user_id)),

    updateChatRoom: (name)=> dispatch(actions.updateChatRoom(ownProps.params.chat_room_id, name)),

    emitAlertMessage: (message)=> dispatch(emitAlertMessage(message, 'topSuccess')),

    deleteChatMessage: (message_id)=> dispatch(actions.deleteChatMessage(ownProps.params.chat_room_id, message_id)),

    reactChat: (message_id, reaction_type)=> dispatch(actions.reactChat(ownProps.params.chat_room_id, message_id, reaction_type)),

    unLikeChat: (message_id, like_id) => dispatch(actions.deleteReactChat(ownProps.params.chat_room_id, message_id, like_id)),

    willMount: (props)=> {
      dispatch(actions.fetchChatRoom(ownProps.params.chat_room_id))
      dispatch(actions.fetchChatMessages(ownProps.params.chat_room_id, 0))
      dispatch(actions.makeChatMessageRead(ownProps.params.chat_room_id))
    },

    willUpdate: (props, nextProps)=> {
			if (props.chatRoom && !nextProps.chatRoom)
        dispatch(actions.closeRightSidePage())
      if (props.params.chat_room_id != nextProps.params.chat_room_id) {
        dispatch(actions.fetchChatRoom(nextProps.params.chat_room_id))
        dispatch(actions.fetchChatMessages(nextProps.params.chat_room_id, 0))
      }
    },

    receiveSocket: (message, message_type, props)=> {
      switch(message_type) {
        /**
         * message_typeのメッセージ受信時
         */
        case 'chat':
        case 'chat_meta_info':
        /**
         * 現在開いているchat_room_idの場合処理をする
         */
          if (message.chat_room_id == ownProps.params.chat_room_id) {
            if (message.deleted) {
              dispatch(actions.removeChatMessage(message.chat_room_id, message.message_id))
            }
            else {
              // 新規投稿メッセージ・添付ファイル(動画)のステータスの変化に関する更新情報のみ取り込むように
              if (message.appending || message.chat.user.user_id || message.chat.files && message.chat.files.length > 0)
                dispatch(actions.loadChatMessage(message.chat, message.appending))
                dispatch(actions.makeChatMessageRead(message.chat_room_id))
            }
          }
          break
        /**
         * chat_room更新情報受信時
         *  現在開いているchat_room_idでかつ、chat_roomが削除された場合／membersに自分自身が含まれていない（自分がチャットルームのメンバーではなくなった）場合
         *  ・ストアからchat_roomを削除するため、パラメータに「true」を渡す
         *  ・rightSidePageを閉じる
         */
        case 'chat_room':
          if (message.chat_room_id != ownProps.params.chat_room_id)
            break
          if (message.deleted || message.chat_room.obsoleted) {
            dispatch(actions.loadChatRoom(message.chat_room, true))
          }
          else
            dispatch(actions.loadChatRoom(message.chat_room, false))
          break
        default:
          break
      }
    },

    requestSync: ()=> dispatch(actions.fetchChatMessages(ownProps.params.chat_room_id, 0)),
  }
}

export default combineHOC(
  translate(),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({ state: { url: false, openDoc: false, pdf: false, openPdf: false, openAlbum: false, individualChatRoom: false}}),
  socketRsync('chat', 'chat_meta_info', 'chat_room'),
  lifecycle,
  trackPage('chat_messages'),
)



// WEBPACK FOOTER //
// ./src/connects/chat-messages-page.js